<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
          <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
          <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
          <v-toolbar-title v-if="tranMode === 'New'">New Default Standard Risk Text</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Review'">Edit Default Standard Risk Text</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Query'">View Existing Default Standard Risk Text</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <!-- <message :messages="messages"></message> -->
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.polType }}</v-subheader>
                <div class="queryValue">{{ form.polType }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-autocomplete
                  :items="poltype"
                  :label="labels.polType"
                  v-model="form.polType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="polType"
                  :data-vv-as="labels.polType"
                  :error-messages="errors.collect('polType')"
                  v-validate="'required'"
                  @change="doBusClsList"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <div class="queryValue">{{ form.busCls }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-autocomplete
                  :items="busClsListByPolType"
                  :label="labels.busCls"
                  v-model="form.busCls"
                  item-text="label"
                  item-value="value"
                  data-vv-name="busCls"
                  :data-vv-as="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                  v-validate="'required'"
                  :disabled="this.form.polType === undefined"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.riskNo }}</v-subheader>
                <div class="queryValue">{{ form.riskNo }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-text-field
                  v-model="form.riskNo"
                  :label="labels.riskNo"
                  :error-messages="errors.collect('form.riskNo')"
                  data-vv-name="form.riskNo"
                  :data-vv-as="labels.riskNo"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.stdRiskTxtRef }}</v-subheader>
                <div class="queryValue">{{ form.stdRiskTxtRef }}</div>
              </v-flex>
              <v-flex lg6 md6 xs12 v-else>
                <v-autocomplete
                  :items="stdrisktxt"
                  :label="labels.stdRiskTxtRef"
                  v-model="form.stdRiskTxtRef"
                  item-text="label"
                  item-value="value"
                  data-vv-name="stdRiskTxtRef"
                  :data-vv-as="labels.stdRiskTxtRef"
                  :error-messages="errors.collect('stdRiskTxtRef')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ form.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ form.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
        <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
          Save
          <v-icon right>mdi-content-save </v-icon>
        </v-btn>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { prtForm, dateType, debtType, acctType } from '@/const/params'

export default {
  data() {
    return {
      // tranMode: 'New',
      newMode: true,
      reviewMode: false,
      queryMode: false,
      submitting: false,
      poltype: [],
      buscls: [],
      busClsListByPolType: [],
      stdrisktxt: [],
      labels: {
        newButton: 'New Default Standard Risk Text',
        polType: 'Policy Type',
        busCls: 'Business Class',
        riskNo: 'Risk No.',
        stdRiskTxtRef: 'Standard Risk Text Reference',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        polType: undefined,
        busCls: undefined,
        riskNo: 1,
        stdRiskTxtRef: undefined,
        createdBy: null,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('poltype')
      this.getCommonDataList('buscls')
      this.getCommonDataList('stdrisktxt')
      this.doFetchData()
    },
    async doFetchData() {
      const apiURI = this.menu.getDefStdRiskTxt
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            polType: this.defStdRiskTxt.polType,
            busCls: this.defStdRiskTxt.busCls,
            riskNo: this.defStdRiskTxt.riskNo,
            stdRiskTxtRef: this.defStdRiskTxt.stdRiskTxtRef
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.polType = data.defStdRiskTxt.polType
            this.form.busCls = data.defStdRiskTxt.busCls
            this.form.riskNo = data.defStdRiskTxt.riskNo
            this.form.stdRiskTxtRef = data.defStdRiskTxt.stdRiskTxtRef
            this.form.createdBy = data.defStdRiskTxt.createdBy
            this.form.createdDate = data.defStdRiskTxt.createdDate
            this.form.modifiedBy = data.defStdRiskTxt.modifiedBy
            this.form.modifiedDate = data.defStdRiskTxt.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    },
    async doBusClsList() {
      const apiURI = this.menu.getBusClsByPolType
      if (apiURI) {
        try {
          const expand = {
            polType: this.form.polType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.busClsListByPolType = []
          if (data) {
            data.map((busCls) => {
              const convertList = {
                label: busCls.busCls + ' - ' + busCls.busClsDesc,
                value: busCls.busCls
              }
              this.busClsListByPolType.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPrtForm() {
      if ((this.form.prtForm === 'C1' || this.form.prtForm === 'C2') && this.form.polType === 'O') {
        this.minUWYr = 1
        this.form.minUWYrPrt = 1
      } else if ((this.form.prtForm === 'R1' || this.form.prtForm === 'R2' || this.form.prtForm === 'R3') && this.form.polType === 'O') {
        this.minUWYr = 2
        this.form.minUWYrPrt = 2
      }
    },
    doCancel() {
      this.$router.push({ name: 'defStdRiskTxt' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createDefStdRiskTxt
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'defStdRiskTxt' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateDefStdRiskTxt
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'defStdRiskTxt' })
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    defStdRiskTxt() {
      return this.$route.params.defStdRiskTxt
    },
    tranMode() {
      return this.$route.params.tranMode
    },
    menu() {
      return this.$store.state.defStdRiskTxtParam.menu
    },
    prtFormList() {
      let result = []
      Object.keys(prtForm).forEach(function (key) {
        const status = prtForm[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    dateTypeList() {
      let result = []
      Object.keys(dateType).forEach(function (key) {
        const status = dateType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    debtTypeList() {
      let result = []
      Object.keys(debtType).forEach(function (key) {
        const status = debtType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    checkRIType() {
      let result = 'entry'
      if (this.form.polType === 'O') {
        result = 'required'
      }
      return result
    }
  },
  created() {
    this.doInit()
    if (this.defStdRiskTxt === undefined && this.tranMode === undefined) {
      this.$router.push({ name: 'defStdRiskTxt' })
    }
    if (this.defStdRiskTxt === 'new') {
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
    } else if (this.tranMode === 'Review') {
      this.newMode = false
      this.reviewMode = true
      this.queryMode = false
      this.doFetchData()
    } else if (this.tranMode === 'Query') {
      this.newMode = false
      this.reviewMode = false
      this.queryMode = true
      this.doFetchData()
    }
    this.doPrtForm()
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, commonAjaxMixin, MessageMixin]
}
</script>
